import React, {
    useCallback,
    useState,
    useRef,
    useEffect
} from "react";

import ArrowIcon from "../../icons/ArrowIcon";
import Button from "../Form/Button";

const Select = ({
    options = [],
    initialOption,
    width,
    label,
    errors,
    verticalPadding,
    height,
    disabled,
    onChange,
}) => {
    const [sortOption, setSortOption] = useState({
        label: initialOption || label,
        value: ""
    });
    const [toggleSubNav, setToggleSubNav] = useState(false);
    const ref = useRef(null);

    const toggleSubNavUI = useCallback(() => {
        if (!disabled) {
            setToggleSubNav(!toggleSubNav);
        }
    }, [toggleSubNav, disabled]);

    const handleSortChange = useCallback(
        (option) => {
            setSortOption({
                label: option.label,
                value: option.value,
            });
            setToggleSubNav(false);
            if (onChange) {
                onChange(option);
            }
        }, [onChange]);

    useEffect(() => {

        if (initialOption) {
            const otherOption = options.filter((itm) => itm.value === initialOption);
            if (otherOption.length > 0) {
                setSortOption(otherOption[0]);
            }
        }
    }, [initialOption, options]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setToggleSubNav(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div ref={ref} className="w-full flex items-center justify-end lg:justify-between">
            <div onClick={toggleSubNavUI} className={`${width ? `w-${width}` : "w-full"} hover:cursor-pointer flex flex-col relative bg-white rounded-[8px]`}>
                <span className={`inline-block absolute top-[-22px] text-xs ${errors ? "text-error" : "text-gray-text"}`}>
                    {label}
                </span>
                <div className={`w-full flex flex-row items-center justify-between px-[16px] ${verticalPadding ? `py-[${verticalPadding}]` : "py-[14px]"} ${height ? `h-[${height}]` : "max-h-[40px]"} border rounded-[8px] relative border-[#E5E7EB]`}>
                    <Button variant="noStyle" className={`mr-[8px] text-[15px] font-medium text-dark text-left`} onClick={toggleSubNavUI}>
                        <span className="text-[15px] text-dark font-medium">
                            {sortOption.label}
                        </span>
                    </Button>
                    <Button variant="noStyle" width="16px" height="16px" onClick={toggleSubNavUI} className={"max-w-[16px] min-w-[16px] min-h-[16px] max-h-[16px] rotate-[90deg] text-secondary-action lg:flex"}>
                        <span className={`w-full inline-block transition-all ${toggleSubNav ? "rotate-[180deg]" : "rotate-[0deg]"}`}>
                            <ArrowIcon />
                        </span>
                    </Button>
                </div>
                {toggleSubNav && (
                    <div className={`w-full shadow-[1px_1px_2px_0px_#0100231A] leading-[1.434] flex flex-col bg-white border border-gray-light max-h-[200px] md:max-h-[300px] overflow-y-auto ${toggleSubNav ? "block" : "hidden"} rounded-[8px] p-[12px] absolute top-full left-0 z-[10] mt-[5px] gap-y-[7.25px]`}>
                        {options.map((option) => (
                            <Button
                                key={option.id}
                                variant="noStyle"
                                onClick={() => handleSortChange(option)}
                                className={`px-[12px] py-[8px] text-dark text-left text-[15px] font-medium hover:text-dark hover:bg-[#F4F4F4] rounded-[8px] ${sortOption.label === option.label ? "bg-[#F4F4F4]" : "bg-transparent"}`}>
                                <span className="text-[15px] text-dark-bg font-normal">
                                    {option.label}
                                </span>
                            </Button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Select;
